import { Component, EventEmitter, forwardRef, Input, OnInit, Output, OnDestroy /*, OnChanges */} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../store';
import { AirportInputComponent } from './airport-input.component';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as BestOffersAction from '../../../../store/actions/best-offers.action';

@Component({
	selector: 'app-airport-input',
	templateUrl: './airport-input.indra.component.html',
	styleUrls: ['./airport-input.component.scss'],
	providers: [
		{
			/**
			 * Custom Control value accessor
			 */
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => INDRAAirportInputComponent),
			multi: true
		}
	]
})
export class INDRAAirportInputComponent extends AirportInputComponent
	implements OnInit, OnDestroy/*, OnChanges */ {
	airport;

	query = this.airport !== null ? this.airport : '';

	@Input() label;
	@Input() label_filled;
	@Input() label_key = null;
	@Input() label_filled_key = null;
	@Input() id;
	@Input() isLoading = false;

	@Input() callback;

	@Input() completeOptions = [];
	@Input() disabledForm = false;
	@Input() instruction = false;
	@Input() placeholder = 'flightStatus.label.countryCityAirport';
	@Input() instructionKey = null
	
	@Input() ariaDescribedby = null;
	
	@Input()
	isTripFinder = false;

	@Input()
	showLastSearch = true;

	@Input()
	dataOptions = []; // select options

	@Output()
	selected = new EventEmitter<any>();

	// @Input()
	// showRecentSearch = true;

	hasFocus = false;
	showAutocomplete = false;

	searchRoutes$: Observable<any> = this.store.select(fromStore.getMiniIBESearchRoutes);
	searchRoutes;

	currentSearch$: Observable<any> = this.store.select(fromStore.getMiniIBECurrentSeachRoute);
	currentSearch: number;

	isAlive = true;

	keyboardInput: string = '';
	
	autocompleteFocusedID: string = null;
	
	// isDisabled = true; // added to disabled input

	// required for ControlValueAccessor
	propagateChange = (_: any) => { };

	constructor(
		private store: Store<fromStore.State>,
	) {
		super();

		this.currentSearch$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => this.currentSearch = value);

		this.searchRoutes$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.searchRoutes = value;
			});

	}

	ngOnInit() { }

	

	ngOnDestroy() {
		this.isAlive = false;
	}

	/**
	 * Print airport name on input
	 */
	get INDRA_printAirportName() {
		if (this.airport && this.airport.location) {
			const airport = this.airport;
			// Check if airport name is diferent then city name
			// const airportName = airport.location.city.toLowerCase() === airport.name.toLowerCase() ? '' : airport.name + ', ';
			// return (
			// 	airport.location.city + ', ' + airportName + airport.location.country
			// );
			return (
				airport.location.city + ', ' + airport.location.country
			);
		}
		if (this.airport && this.airport['type']) {
			return this.airport['value'].label;
		}
		return this.keyboardInput;
	}

	/**
	 * Print airport iata code on input
	 */
	INDRA_printAirportCode() {
		if (this.airport && this.airport.location) {
			const airport = this.airport;
			return airport.code;
		}
		if (this.airport && this.airport['type']) {
			return this.airport['value'].icon;
		}
		return '';
	}

	// Returns whether form control (gotten by key) has a value;
	INDRA_printLabel(): boolean {
		return !this.airport ? this.label : this.label_filled;
	}

	INDRA_getLabelKey(): string {
		return !this.airport ? this.label_key : this.label_filled_key;
	}

	INDRA_handleInputChange(e) {
		if (this.airport) {
			const diff = (diffMe, diffBy) => diffMe.split(diffBy).join('');
			this.keyboardInput = diff(e.target.value, this.airport.location.city + ', ' + this.airport.location.country);
		}

		this.airport = null;
		this.hasFocus = true;
		this.showAutocomplete = true;

		this.query = e.target.value;
		this.propagateChange(e.target.value);
	}

	INDRA_handleInputFocus(e) {
		this.store.dispatch(new MiniIBEActions.PutActiveInput(this.label_filled.toLowerCase()));
		// clears query of automplete if no INDRA_printAirportName is retrieved..
		if (this.INDRA_printAirportName.length == 0) {
			this.query = '';
		}
		this.hasFocus = true;
		this.showAutocomplete = true;
	}

	INDRA_handleInputBlur(e) {

		this.hasFocus = false;
		const dataOption = this.dataOptions ? this.dataOptions.find(optionItem => (optionItem.location.city + ', ' + optionItem.location.country) === this.INDRA_printAirportName) : this.dataOptions;
			
		if (!dataOption && !this.airport) {
			// clears everything (except for query) if no valid airport was selected from autocomplete
			this.keyboardInput = '';
			const input = <HTMLInputElement>document.getElementById(this.id + '');
			if (input) {
				input.value = '';
			}
			this.selected.emit(null);
		}
		setTimeout(() => {
			if (!this.hasFocus) {
				this.showAutocomplete = false;
			}
		}, 300);
		if (this.airport instanceof Object) {
			this.propagateChange(this.airport);
		}
	}
	
	INDRA_handleFocusedId(e) {
		this.autocompleteFocusedID = e;
	}

	INDRA_handleSelect(e) {
		if (e !== null) {
			this.hasFocus = false;
			this.showAutocomplete = false;
		}
		
		if (e && e.type == 'recent-search') {
			let newSearchRoutes = Object.assign([], this.searchRoutes);
			if (this.searchRoutes.length >= this.currentSearch + 1) {
				newSearchRoutes = newSearchRoutes.map((cur, idx) => {
					if (idx === this.currentSearch) cur = e.value;
					return cur;
				});
			} else {
				newSearchRoutes.push(e.value);
			}

			this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
			this.store.dispatch(new MiniIBEActions.PutSearchRoute(newSearchRoutes));
		} 
		else {

			this.writeValue(e);
			this.propagateChange(e);
		}
		
		if (e) {
			this.selected.emit(e);
		}
	}

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched() { }

	writeValue(value: any) {
		this.airport = value;
	}

	INDRA_class() {
		const result = [];
		if (!!this.airport && this.airport.code !== undefined  && !this.isLoading) result.push('filled');
		if (!!this.airport && this.airport.code === undefined) {
			this.airport = null;
		}
		if (this.hasFocus) result.push('focus');
		if (this.disabledForm) result.push('is-disabled');
		if (this.instruction) result.push('has-instruction');
		if (this.isLoading) result.push('is-loading');
		return result.join(' ');
	}

	/*ngOnChanges() {
		this.INDRA_enableInput();
	}

	INDRA_enableInput() {
		if (this.dataOptions && this.dataOptions.length > 0) {
			this.isDisabled = false;
		} else {
			this.isDisabled = true;
		}
	}*/
}
